import type { CarType } from "../../../../shared-logic/types/CarType";

export const INIT_CAR = "car/init" as const;

type InitCarType = { type: typeof INIT_CAR; car: CarType };

export const initCar = (car: CarType): InitCarType => ({ type: INIT_CAR, car });

export type CarActionsType = InitCarType;
